import React from "react";
import { AspectRatio, Box, Text } from "@chakra-ui/layout";
import { Img } from "@chakra-ui/react";

const getImgUrl = (gif: any) => gif.images.downsized_medium.url;

export const Item = ({
  name,
  gif,
  onClick,
  onDragStart,
  onDragEnd,
}: {
  name?: string;
  gif: any;
  onClick?: any;
  onDragStart?: any;
  onDragEnd?: any;
}) => {
  return (
    <Box
      cursor={onClick && "pointer"}
      onClick={onClick}
      borderRadius="5px"
      position="relative"
      onDragStart={(event) => {
        if (onDragStart) {
          onDragStart(event);
        }
      }}
      onDragEnd={(event) => {
        if (onDragEnd) {
          onDragEnd(event, {
            client: {
              x: event.clientX,
              y: event.clientY,
            },
            screen: {
              x: event.screenX,
              y: event.screenY,
            },
            page: {
              x: event.pageX,
              y: event.pageY,
            },
            movement: {
              x: event.movementX,
              y: event.movementY,
            },
          });
        }
      }}
    >
      <AspectRatio>
        <Img
          borderRadius="5px"
          src={getImgUrl(gif)}
          //@ts-ignore
          ratio={136 / 110}
        />
      </AspectRatio>

      {name && (
        <Box
          bgColor="#20202350"
          css={{ backdropFilter: "blur(1px)" }}
          px="10px"
          py="4px"
          left="50%"
          mr="-50%"
          transform="translate(-50%, -50%)"
          position="absolute"
          top="50%"
          //@ts-ignore
          align="center"
        >
          <Text
            textTransform="uppercase"
            fontFamily="Apple SD Gothic Neo"
            fontWeight="800"
            fontSize="3.7vw"
            color="white"
          >
            {name}
          </Text>
        </Box>
      )}
    </Box>
  );
};
